module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Shuffle-7a446db81b633c96d26450e3feb525597c6c3df70308e4af7fa36a1615daf8dc.svg";